export default {
    "alwaysChallenge": false
}
